export default __webpack_public_path__ + "static/media/5No filas.84570528.svg";